var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, IsNumber, IsOptional, Min } from 'class-validator';
export class Cage {
    constructor(data) {
        this.id = '';
        this.number = '';
        this.length = 0;
        this.width = 0;
        this.height = 0;
        this.dimensionUnit = 'cm';
        Object.assign(this, data);
    }
    get dimensions() {
        return {
            length: this.length,
            width: this.width,
            height: this.height,
            unit: this.dimensionUnit
        };
    }
    get area() {
        return this.length * this.width;
    }
    get volume() {
        return this.length * this.width * this.height;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], Cage.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Cage.prototype, "number", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Cage.prototype, "length", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Cage.prototype, "width", void 0);
__decorate([
    IsNumber(),
    Min(0),
    __metadata("design:type", Number)
], Cage.prototype, "height", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Cage.prototype, "dimensionUnit", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cage.prototype, "location", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cage.prototype, "description", void 0);
